import { defaultPaddingLeft, defaultPaddingTop, mobileDefaultPadding } from '../../../../../constants/sizes';
import Device from '../../../../../constants/deviceSizes';

export default {
  container: {
    width: '100%',
    boxSizing: 'border-box',
    padding: `${defaultPaddingTop}px ${defaultPaddingLeft}px`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'justify',
    [Device.mobile]: {
      padding: mobileDefaultPadding
    }
  },
  subtitle: {
    width: '100%'
  },
  excludeSubtitle: {
    padding: '5px 0px 10px'
  },
  bullets: {
    paddingTop: 6,
    width: '100%',
    textAlign: 'justify'
  },
  button: {
    margin: '20px 0px 15px',
    [Device.mobile]: {
      alignSelf: 'center'
    }
  },
  topbar: {
    [Device.mobile]: {
      paddingLeft: 10
    }
  },
  itemContentContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    textAlign: 'justify',
    minHeight: 30,
    paddingTop: 8,
    width: '70%',
    [Device.mobile]: {
      width: '100%'
    }
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    [Device.mobile]: {
      justifyContent: 'space-around'
    }
  },
  cancel: {
    marginRight: 10
  }
};
